import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const YouTubeVideoWithCTA = ({ videoId, ctaLink, ctaText }) => {
  const [showCTA, setShowCTA] = useState(false);
  const [hideCTA, setHideCTA] = useState(false);

  useEffect(() => {
    let player;
    let interval;

    const onYouTubeIframeAPIReady = () => {
      player = new window.YT.Player(`youtube-video-${videoId}`, {
        videoId: videoId,
        events: {
          onReady: (event) => {
            interval = setInterval(() => {
              const currentTime = event.target.getCurrentTime();
              if (currentTime >= 120) {
                setShowCTA(true);
                clearInterval(interval); // Stop checking after it shows
                setTimeout(() => setHideCTA(true), 8000); // Auto-hide after 8 seconds
              }
            }, 1000);
          },
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              clearInterval(interval);
            }
          },
        },
      });
    };

    if (!window.YT || !window.YT.Player) {
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      script.async = true;
      document.body.appendChild(script);
    } else {
      onYouTubeIframeAPIReady();
    }

    return () => {
      if (interval) clearInterval(interval);
      if (player) player.destroy();
    };
  }, [videoId]);

  return (
    <div className="relative w-full h-[400px] md:h-[500px] rounded-lg shadow-lg overflow-hidden">
      <div id={`youtube-video-${videoId}`} className="w-full h-full"></div>

      {/* YouTube-Style CTA Overlay */}
      {showCTA && !hideCTA && (
        <Link
          to={ctaLink}
          className="absolute top-4 right-4 bg-white/90 border border-gray-300 shadow-lg rounded-md px-4 py-2 flex items-center text-sm hover:bg-gray-100 transition"
        >
          <p className="text-gray-900 font-medium leading-tight mr-2">
            {ctaText}
          </p>
          <span className="text-gray-500 text-lg">ℹ️</span>
        </Link>
      )}
    </div>
  );
};

export default YouTubeVideoWithCTA;
